$(document).ready(function () {

    $('.cstm_variant_option').click(function () {
        var new_val = $(this).attr('data-value');
        $('.cstm_piece').text(new_val);
    });

    $(document).on('click', '.cstm_variant_option', function () {
   
        var modal_urll = $(this).attr('variant-url');
        // console.log(modal_urll);
        var modalInner = $(this).parents('.modal__inner');
        // console.log(modalInner); // Debug line

        if (modal_urll && modalInner.length) {
            modalInner.find('.view-details-btn').attr('href', modal_urll);
        }
    });

});

let productBundle = 0;

$(document).on("click", ".quick-product__btn", function () {
    let closestContainer = $(this).closest(".grid__item");
    setTimeout(function () {
        let bundledProduct = closestContainer.find(".modal--is-active").find(".bundled_product");
        if (bundledProduct.length > 0) {
            productBundle = $('.bundled_product').length;
            window.cartBoxLimit = productBundle;
        } else {
            $('.add-to-cart').removeClass('bundle-disable');
        }
    }, 4000);
});

window.cartBox = [];
window.cartBoxTotal = 0;
window.cartBoxTotalItem = 0;

let formids = $(".cst-roo-and-you-formid").attr("formid");
const form_id = formids;

class ProductBundleItem extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        this.productId = this.dataset.id;
        this.querySelectorAll('.variant-input-wrap label.disabled').forEach(label => {
            label.addEventListener('click', e => e.preventDefault());
        });
    }

    addItem() {
        let added = window.cartBox.find(item => item.proId == this.productId);
        this.classList.add('added');

        if (!added) {
            window.cartBox.push({
                proId: this.productId,
                id: this.currentVariant.id,
                quantity: 1
            });
        } else {
            added.id = this.currentVariant.id;
        }

        if (window.cartBox.length >= window.cartBoxLimit && document.querySelector('.product-section .add-to-cart')) {
            document.querySelector('.product-section .add-to-cart').classList.remove('bundle-disable');
            if (document.querySelector('.product-sticky-atc-section')) {
                var stickyAddToCartButton = document.querySelector('.product-sticky-atc-section .add-to-cart');
                var stickyForm = document.querySelector('.product-sticky-atc-section form');
                stickyAddToCartButton.classList.remove('bundle-disable');
                if (!stickyAddToCartButton.classList.contains('bundle-disable')) {
                    stickyForm.addEventListener('submit', function (event) {
                        event.preventDefault();
                        $('.product-section .add-to-cart').click();
                    });
                }
            }
        }
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);

        if (!this.currentVariant) {
            //this.toggleAddButton(true, '', true);
            // this.setUnavailable();
        } else {
            this.addItem();
            if (!this.currentVariant) return;
            if (!this.currentVariant.featured_media) return;
            this.querySelector('img').src = this.currentVariant.featured_media.preview_image.src;
        }
    }

    updateSize(currentSize) {
        let size = this.querySelector('.size-dropdown');
        let options = size.querySelectorAll('option');
        options.forEach(option => {
            if (option && option.value.split('-')[0] == currentSize) {
                option.selected = true;
                size.value = option.value;
                this.onVariantChange();
            }
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        const radioOption = fieldsets.map((fieldset) => {
            let item = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            if (item) return item.value;
        });
        const selectOption = Array.from(this.querySelectorAll('select'), (select) => select.value);
        this.options = [...radioOption, ...selectOption];
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = this.querySelector('.add-item-btn');
        if (!addButton) return;
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
        } else {
            addButton.removeAttribute('disabled');
        }
        if (!modifyClass) return;
    }

    renderProductInfo() {
        let price = this.currentVariant.price;
        let comparePrice = this.currentVariant.compare_at_price;
        let format = '{{shop.money_format}}';

        if (price < comparePrice) {
            this.querySelector('.price').classList.add('price--on-sale');
            this.querySelector('.price-item--regular').textContent = formatMoney(comparePrice, format);
            this.querySelector('.price-item--last').textContent = formatMoney(price, format);
        } else {
            this.querySelector('.price').classList.remove('price--on-sale');
            this.querySelector('.price-item--regular').textContent = formatMoney(price, format);
            this.querySelector('.price-item--last').textContent = formatMoney(price, format);
        }
    }
}

customElements.define('product-bundle', ProductBundleItem);

function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';
        if (isNaN(number) || number === null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
    }
    return formatString.replace(placeholderRegex, value);
}

document.addEventListener('variantImageChange', ()=>{

})

function initColorSwatch(container) {
    var maxVisibleSwatches = 6;
    var colorSwatchesContainer = container;
    var colorSwatches = Array.from(colorSwatchesContainer.querySelectorAll('.color-swatch')).filter(function (swatch) {
        return window.getComputedStyle(swatch).display !== 'none';
    });
    var colorCount = parseInt(container.dataset.productVariantsCount);
    var containerProductHandle = container.dataset.productHandle


    if (colorCount > maxVisibleSwatches) {

        // Add + X other colors available label
        var moreColorsLabel = document.createElement('div');
        moreColorsLabel.className = 'toggle-colors-label';
        moreColorsLabel.textContent = `+ ${colorCount - maxVisibleSwatches}`;
        colorSwatchesContainer.appendChild(moreColorsLabel);

        moreColorsLabel.addEventListener('click', function (event) {
            // Stop the click event from propagating to the color swatches
            event.stopPropagation();

            // Always re-query — get the freshest set of children
            const colorSwatches = Array.from(
                colorSwatchesContainer.querySelectorAll('.color-swatch')
            );
            if (moreColorsLabel.textContent.includes('Show less')) {
                // Hide swatches exceeding the maxVisibleSwatches limit
                for (var i = maxVisibleSwatches; i < colorCount; i++) {
                    colorSwatches[i].style.display = 'none';
                }
                // Change label to show more colors
                moreColorsLabel.textContent = `+ ${colorCount - maxVisibleSwatches}`;
                container.dataset.expanded = false
            } else {
                //dont redownload all of the swatches
                if (container.dataset.swatchesLoaded) {
                    for (var i = maxVisibleSwatches; i < colorCount; i++) {
                        colorSwatches[i].style.display = 'inline-block';
                    }
                }else {
                    fetch(
                        window.Shopify.routes.root + "products/" + containerProductHandle + "?sections=independent-swatch-control"
                    )
                        .then(res => res.json())
                        .then(data => {
                            let htmlString = data["independent-swatch-control"];
                            let parser = new DOMParser();
                            let doc = parser.parseFromString(htmlString, "text/html");

                            let links = Array.from(doc.querySelectorAll("a"));
                            container.querySelectorAll('a').forEach(a => a.remove())
                            container.prepend(...links)

                            moreColorsLabel.textContent = 'Show less';
                            container.dataset.expanded = false;
                            container.dataset.swatchesLoaded = true;


                        })
                        .catch(err => console.error("Fetch failed:", err));

                }
            }
        });
    }
}

function initColorSwatches(){
    document.querySelectorAll('.grid-product__colors').forEach(function (container) {
        initColorSwatch(container);
    })
}
document.addEventListener('DOMContentLoaded', function() {
    initColorSwatches();
});

document.addEventListener('recommendations:loaded', function() {
    initColorSwatches();
});
